import Icon from "@material-ui/icons/SupervisedUserCircle";
import ParentList from "./ParentList";
import ParentCreate from "./ParentCreate";
import ParentEdit from "./ParentEdit";
import ParentShow from "./ParentShow";

// eslint-disable-next-line import/no-anonymous-default-export
export default {
  name: "parents",
  create: ParentCreate,
  list: ParentList,
  show: ParentShow,
  edit: ParentEdit,
  icon: Icon,
};
